import {
  Edit,
  SimpleForm,
  NumberInput,
  TextInput,
  DateInput,
  required,
  minValue,
} from "react-admin";
import type { EditProps } from "react-admin";

export const ProjectPaymentEdit = (props: EditProps) => (
  <Edit
    {...props}
    transform={(data: Record<string, unknown>) => ({
      amount: Number(data.amount),
      paidDate: data.paidDate,
      payeeName:
        typeof data.payeeName === "string" ? data.payeeName.trim() || undefined : data.payeeName,
      purpose: typeof data.purpose === "string" ? data.purpose.trim() || undefined : data.purpose,
      paymentMode: String(data.paymentMode ?? "").trim(),
      paymentRef:
        typeof data.paymentRef === "string" ? data.paymentRef.trim() || undefined : data.paymentRef,
      remarks: typeof data.remarks === "string" ? data.remarks.trim() || undefined : data.remarks,
    })}
  >
    <SimpleForm>
      <NumberInput source="amount" validate={[required(), minValue(1)]} />
      <DateInput source="paidDate" validate={required()} />
      <TextInput source="payeeName" label="Payee / vendor" fullWidth />
      <TextInput source="purpose" label="Purpose / description" fullWidth multiline />
      <TextInput source="paymentMode" label="Payment mode" validate={required()} fullWidth />
      <TextInput source="paymentRef" label="Reference" fullWidth />
      <TextInput source="remarks" multiline fullWidth />
    </SimpleForm>
  </Edit>
);
